import React from "react";

export function StatCard({ label, value, sub, tone = "default", testid }) {
  const tones = {
    default: "border-zinc-200 bg-white",
    danger:  "border-rose-200 bg-rose-50",
    warn:    "border-amber-200 bg-amber-50",
    good:    "border-emerald-200 bg-emerald-50",
    dark:    "border-zinc-900 bg-zinc-900 text-white",
  };
  const valueColor = {
    default: "text-zinc-900",
    danger:  "text-rose-700",
    warn:    "text-amber-700",
    good:    "text-emerald-700",
    dark:    "text-white",
  }[tone];
  const subColor = tone === "dark" ? "text-zinc-400" : "text-zinc-500";
  return (
    <div data-testid={testid} className={`border p-5 ${tones[tone]}`}>
      <div className={`text-[10px] tracking-[0.18em] uppercase font-semibold ${subColor}`}>{label}</div>
      <div className={`mt-3 font-heading font-black text-4xl tabular ${valueColor}`}>{value}</div>
      {sub ? <div className={`mt-2 text-xs ${subColor}`}>{sub}</div> : null}
    </div>
  );
}

export function StatusBadge({ status }) {
  const cfg = {
    Completed:   ["bg-emerald-100 text-emerald-800", "Completed"],
    "In Progress": ["bg-blue-100 text-blue-800", "In Progress"],
    Pending:     ["bg-amber-100 text-amber-800", "Pending"],
    Overdue:     ["bg-rose-100 text-rose-800", "Overdue"],
  }[status] || ["bg-zinc-100 text-zinc-800", status];
  return (
    <span className={`inline-flex items-center px-2 py-0.5 text-[11px] font-semibold tracking-wide ${cfg[0]}`}>
      {cfg[1]}
    </span>
  );
}

export function PriorityBadge({ priority }) {
  const cfg = {
    High:   "bg-zinc-900 text-white",
    Medium: "bg-zinc-200 text-zinc-800",
    Low:    "bg-white text-zinc-600 border border-zinc-300",
  }[priority] || "bg-zinc-200 text-zinc-800";
  return <span className={`inline-flex items-center px-2 py-0.5 text-[10px] font-bold tracking-[0.14em] uppercase ${cfg}`}>{priority}</span>;
}
